// extracted by mini-css-extract-plugin
export var description = "rich-text-media-module--description--51d27";
export var root = "rich-text-media-module--root--0a285";